import { createFileRoute } from '@tanstack/react-router'
import { VirtualReportDetailPage } from 'pages/virtualReports/VirtualReportDetailPage'

export const Route = createFileRoute('/virtual-reports/$siteID/$componentID')({
  component: RouteComponent,
  staticData: {
    title: 'Virtual Report',
    layout: {
      showNavbar: true,
      enableScrolling: false,
    },
  },
})

function RouteComponent() {
  return <VirtualReportDetailPage />
}
